import {checkboxAnatomy} from "@chakra-ui/anatomy";
import {createMultiStyleConfigHelpers} from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    borderColor: "transparent !important",
    backgroundColor: "blackAlpha.300",
  },
});

const primary = definePartsStyle({
  control: {
    _checked: {
      background: "brand.300",
      borderColor: "brand.300",
      _hover: {
        background: "brand.300",
        borderColor: "brand.300",
      },
    },
    _hover: {
      background: "brand.300",
      borderColor: "brand.300",
    },
    _invalid: {
      _checked: {
        background: "error",
        borderColor: "error",
      },
    },
  },
});

export const checkboxTheme = defineMultiStyleConfig({
  baseStyle,
  variants: { primary },
  defaultProps: { variant: "primary" },
});
